module.exports = __webpack_public_path__ + "img/Pdf.4fd3201a.svg";